import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { HeaderService } from '../../template/header/header.service';
import { ProductService } from '../product.service';

@Component({
  selector: 'eM-product-create',
  templateUrl: './product-create.component.html',
  styleUrls: ['./product-create.component.css']
})
export class ProductCreateComponent implements OnInit {

  constructor(private brandService: ProductService, private router: Router, private headerService: HeaderService, private route: ActivatedRoute) {

    this.headerService.headerData = {
      title: 'Gestao de Produto -> Produto -> Adicionar',
      icon: 'local_mall',
      routeUrl: '/products'

    }
  }
  ngOnInit(): void {
  }

}
